export const mainDashboardQuery = `query GetCustomer($id: ID!, $dueDate: String!) {
  getCustomer(id: $id) {
    id
    defectsByStatus (status: {     
      between: ["NEW", "REVOKED"]
      }
      limit:1000
      ) {
        items {
            id
            redTag
            status
            defectType
            defectDesc
            reportedDateTime
            sourceType
            vehicle { id }
        }
    }
    inspectionsByDueDate (nextInspectionDue: {     
      le: $dueDate
   }) {
     items {
         id
         nextInspectionDue
         vehicle {id}
     }
 }calbitCustomerID
 companyName
 customerFirstName
 customerLastName

 email
 registrationDate
 picture {
   bucket
   region
   key
 }
 accountStatus
 customerOverAllRating
 vehicles
 (filter: {vehicleStatus:{ne:RETIRED}}
  limit:1000) 
 {
   items {
     id
     customerVehicleId
     make
     model
     VIN
     vehicleYear
     license
     locationLat
     locationLong
     notes
     deactivateBIT
     deactivateDOT
     specialInstructions
     vehicleStatus
     mainPic{
      bucket
      region
      key
     }
     nextInspectionDue {
       
        inspectionType
        nextDueDate
       
     }
     inspections {
      items {
        id
        customerId
        vehicleId
        dvirVehicleInCombination
        inspectorUserType
        inspectorUserId
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        notes
        createdAt
        updatedAt
      }
      nextToken
    }
     vehicleType {
       id
       vehicleType
       vehicleCategory
       observations
     }
   }
   nextToken
 }
 customerTeam {
   items {
     id
     empType
     empName
     phoneNo
     email
     accountStatus
     registrationDate
     notes
     username
   }
   nextToken
 }
 userReviews {
   id
   reviewedby
   rating
   reviewTitle
   reviewDetails
   otherDetails
   reviewDate
 }
 generalInstructions
 inspectors {
   items {
     id
     inspectorID
     customerID
   }
   nextToken
 }
 vendors {
   items {
     id
     vendorID
     customerID
   }
   nextToken
 }
 registeredInspectionType
}
}
`;

export const getVendorExt = `query GetVendor($id: ID!) {
  getVendor(id: $id) {
    customers {
      items {
        customer {
          id
          picture {
            bucket
            key
            region
          }
          companyName
        }
      }
    }
    companyName
    firstName
    lastName
    id
    phoneNo
    picture {
      bucket
      key
      region
    }
  }
}`

export const getVendorTeamExt = `query GetVendorTeam($id: ID!) {
    getVendorTeam(id: $id) {
      id
      vendor {
        id
        vendorType
        companyName
        firstName
        lastName
        phoneNo
        email
        address {
          phoneNo
          faxNo
          address
          city
          state
          zipCode
          addressType
          locationLat
          locationLong
        }
        accountStatus
        picture {
          bucket
          region
          key
        }
        vendorTeam {
          nextToken
        }
        customers {
          items {
            customer {
              id
              picture {
                bucket
                key
                region
              }
              companyName
            }
          }
        }
        notes
        createdAt
        updatedAt
      }
      empType
      firstName
      lastName
      phoneNo
      email
      accountStatus
      notes
      picture {
        bucket
        region
        key
      }
      createdAt
      updatedAt
    }
  }
`;

export const getDefect = `query GetDefect($id: ID!) {
  getDefect(id: $id) {
    id
    customerId
    vehicle {
      id
      customerVehicleId
      inspections {
        nextToken
      }
      customer {
        id
        calbitCustomerID
        companyName
        customerFirstName
        customerLastName
        email
        registrationDate
        accountStatus
        customerOverAllRating
        generalInstructions
        registeredInspectionType
      }
      make
      model
      VIN
      vehicleYear
      license
      locationLat
      locationLong
      nextInspectionDue {
        inspectionType
        nextDueDate
      }
      notes
      currentMileage
      currentMileageLastUpdated
      vehicleType {
        id
        vehicleType
        vehicleCategory
        observations
      }
      specialInstructions
      vehicleUploads {
        bucket
        region
        key
      }
      oilService {
        oilServiceType
        intervalValue
        currentMileage
        currentMileageLastUpdated
        lastTimeOilChangedAt
      }
      filters {
        filterCategory
        filterNumber
        notes
      }
      specialParts {
        partName
        partNumber
      }
      vehicleStatus
      defects {
        nextToken
      }
    }
    defectType
    defectDesc
    redTag
    status
    reportedByUserType
    reportedByUserId
    reportedDateTime
    sourceType
    sourceId
    assignedToUserType
    assignedToUserId
    assignedAtDateTime
    assignedByUserId
    repairedByUserType
    repairedByUserId
    repairedDateTime
    repairNotes
    partsUsedInRepair
    priority
  }
}
`;

export const myGetCustomer = `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    calbitCustomerID
    companyName
    customerFirstName
    customerLastName
    customerAddresses {
      phoneNo
      faxNo
      address
      city
      state
      zipCode
      addressType
      locationLat
      locationLong
    }
    email
    registrationDate
    picture {
      bucket
      region
      key
    }
    accountStatus
    customerOverAllRating
    vehicles {
      items {
        id
        customerVehicleId
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        notes
        currentMileage
        currentMileageLastUpdated
        specialInstructions
        vehicleStatus
        deactivateBIT
        deactivateDOT
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
        }
      }
      nextToken
    }
    customerTeam {
      items {
        id
        empType
        empName
        phoneNo
        email
        accountStatus
        registrationDate
        notes
        username
      }
      nextToken
    }
    userReviews {
      id
      reviewedby
      rating
      reviewTitle
      reviewDetails
      otherDetails
      reviewDate
    }
    generalInstructions
    inspectors {
      items {
        id
        inspectorID
        customerID
      }
      nextToken
    }
    vendors {
      items {
        id
        vendorID
        customerID
      }
      nextToken
    }
    registeredInspectionType
    defectsByStatus {
      items {
        id
        customerId
        vehicleId
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
      }
      nextToken
    }
    inspectionsByDueDate {
      items {
        id
        customerId
        vehicleId
        inspectorUserType
        inspectorUserId
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        notes
      }
      nextToken
    }
  }
}
`;

export const myGetCustomerExtended = `query GetCustomer($id: ID!) {
  getCustomer(id: $id) {
    id
    calbitCustomerID
    companyName
    customerFirstName
    customerLastName
    customerAddresses {
      phoneNo
      faxNo
      address
      city
      state
      zipCode
      addressType
      locationLat
      locationLong
    }
    email
    registrationDate
    picture {
      bucket
      region
      key
    }
    accountStatus
    customerOverAllRating
    vehicles {
      items {
        id
        customerVehicleId
        make
        model
        VIN
        vehicleYear
        license
        locationLat
        locationLong
        notes
        deactivateBIT
        deactivateDOT
        currentMileage
        currentMileageLastUpdated
        specialInstructions
        vehicleStatus
        inspections {
          items {
            id
            customerId
            vehicleId
            dvirVehicleInCombination
            inspectorUserType
            inspectorUserId
            inspectionType
            inspectionStatus
            startAt
            endAt
            nextInspectionDue
            inspectionObservations
            notes
            createdAt
            updatedAt
          }
          nextToken
        }
        nextInspectionDue {
          inspectionType
          nextDueDate
        }
        vehicleType {
          id
          vehicleType
          vehicleCategory
          observations
        }
      }
      nextToken
    }
    customerTeam {
      items {
        id
        empType
        empName
        phoneNo
        email
        accountStatus
        registrationDate
        notes
        username
      }
      nextToken
    }
    userReviews {
      id
      reviewedby
      rating
      reviewTitle
      reviewDetails
      otherDetails
      reviewDate
    }
    generalInstructions
    inspectors {
      items {
        id
        inspectorID
        customerID
      }
      nextToken
    }
    vendors {
      items {
        id
        vendorID
        customerID
      }
      nextToken
    }
    registeredInspectionType
    defectsByStatus(status: {     
      between: ["NEW", "PENDING"]
      }
      limit:10000
      ) {
      items {
        id
        customerId
        vehicleId
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        repairedByUserType
        repairedByUserId
        repairedDateTime
        partsUsedInRepair
      }
    }
    inspectionsByDueDate {
      items {
        id
        customerId
        vehicleId
        inspectorUserType
        inspectorUserId
        inspectionType
        inspectionStatus
        startAt
        endAt
        nextInspectionDue
        inspectionObservations
        notes
      }
      nextToken
    }
  }
}
`;
export const getVehicleDefects = `query GetVehicle($id: ID!) {
  getVehicle(id: $id) {
    id
    customerVehicleId
    make
    model
    VIN
    nextInspectionDue {
      inspectionType
      nextDueDate
    }
      
    vehicleType {
      id
      vehicleType
      vehicleCategory
      observations
    }
    mainPic {
      bucket
      region
      key
    }
    
   
    vehicleStatus
    defects (limit:100000
      filter:{status: {     
        between: ["ASSIGNED", "PENDING"]
        }}) {
        items {
        id
        customerId
        vehicleId
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
      }
      nextToken
    }
  }
}
`;
export const archivedDefects = `query GetVehicle($id: ID!) {
  getVehicle(id: $id) {
    id
    customerVehicleId
    make
    model
    VIN
    nextInspectionDue {
      inspectionType
      nextDueDate
    }
      
    vehicleType {
      id
      vehicleType
      vehicleCategory
      observations
    }
    mainPic {
      bucket
      region
      key
    }
    
   
    vehicleStatus
    defects (limit:100000
      filter:{status: {     
        between: ["REPAIRED", "REVOKED"]
        }}) {
        items {
        id
        customerId
        vehicleId
        defectType
        defectDesc
        redTag
        priority
        status
        reportedByUserType
        reportedByUserId
        reportedDateTime
        sourceType
        sourceId
        assignedToUserType
        assignedToUserId
        assignedAtDateTime
        assignedByUserId
        repairedByUserType
        repairedByUserId
        repairedDateTime
        repairNotes
        partsUsedInRepair
      }
      nextToken
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/data/customQueries.js